exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.unsavedChanges[data-v-65f300fd] {\n  max-height: 0;\n  padding: 0;\n  transition: all ease-in-out 400ms;\n  height: 0;\n  overflow: hidden;\n}\n.unsavedChanges.active[data-v-65f300fd] {\n    max-height: none;\n    padding: 0.25rem 0;\n    height: 1.9rem;\n}\n.tabs-component[data-v-65f300fd] {\n  min-height: 500px;\n}\n.tabs-component-panel[data-v-65f300fd] {\n  overflow: visible !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-65f300fd","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/tools/modal/ReservationEdit.vue
// module id = 1658
// module chunks = 0